import { render, staticRenderFns } from "./personMobel.vue?vue&type=template&id=8953f722&scoped=true&"
import script from "./personMobel.vue?vue&type=script&lang=js&"
export * from "./personMobel.vue?vue&type=script&lang=js&"
import style0 from "./personMobel.vue?vue&type=style&index=0&id=8953f722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8953f722",
  null
  
)

export default component.exports